/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-shadow */
import React from 'react';
import { EDULAI_BLUE, EDULAI_PURPLE, RED } from '../../styles/styleConsts';
import { Box, Paper, Typography } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { TypingDots } from './TypingDots';
import { hasError, isAnswer, isQuestion, isStatusPending, isWritingResponse } from '../../utils/Chat/ChatUtil';
import translations from '../../translations/i18next';
import RetryAIButton from '../Buttons/RetryAIButton';
import './markdown.css';

const ChatMessages = (props) => {
  const { messages } = props;

  if (!messages.length) {
    return (
      <Box display={'flex'} justifyContent={'center'}>
        <Box
          style={{
            backgroundColor: 'rgba(77, 102, 185, 0.08)',
            paddingLeft: 20,
            paddingRight: 20,
            width: '90%',
            marginTop: 40,
            border: `1px solid ${EDULAI_PURPLE}`,
            borderRadius: 8,
            color: EDULAI_PURPLE,
            fontSize: 16,
            alignSelf: 'center'
          }}
        >
          <Markdown>{translations.t('chat.coachAIMessage')}</Markdown>
        </Box>
      </Box>
    );
  }

  return (
    <Box flex={1} p={1.5}>
      {messages.map((m, index) => {
        const isQ = isQuestion(m);
        const isA = isAnswer(m);
        const isError = hasError(m);
        const isPending = isStatusPending(m);
        const isWriting = isWritingResponse(m);

        if (m.hide) return null;

        return (
          <Box key={m.id} display="flex" justifyContent={isQ ? 'flex-end' : 'flex-start'} mb={1}>
            <Paper
              elevation={0}
              style={{
                background: isError ? '#ffebee' : isQ ? 'rgba(77, 102, 185, 0.08)' : '#f5f5f5',
                padding: '8px 12px',
                borderRadius: 12,
                maxWidth: '70%',
                opacity: isPending ? 0.9 : 1,
                border: isError ? '1px solid #ef5350' : '1px solid transparent',
                color: isError ? '#c62828' : isQ ? EDULAI_PURPLE : undefined,

                whiteSpace: 'normal',
                
              }}
            >
              {isQ && <Typography variant="body2">{m.content}</Typography>}
              {isWriting && <TypingDots color={EDULAI_BLUE} size={6} gap={4} />}
              {isA && (
                <Typography component="div" variant="body2">
                  <Markdown
                    parserOptions={{ pedantic: true }}
                    className="markdown-body"
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />
                    }}
                  >
                    {m.content}
                  </Markdown>
                </Typography>
              )}
              {isA && index === messages.length - 1 && !isPending && (
                <Box display={'flex'} justifyContent={'flex-end'}>
                  <RetryAIButton onClick={props.onRetryQuestion} color={'grey'} fontSize={16} />
                </Box>
              )}
              {isError && (
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  <ErrorOutline fontSize="small" />
                  <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', marginLeft: 5 }}>
                    {translations.t('chat.messageError')}
                  </Typography>
                  <RetryAIButton onClick={props.onRetryQuestion} color={RED} />
                </div>
              )}
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default ChatMessages;
